<template>
    <div class="box_input">
        <strong class="tit">{{$t('EnrolmentQuestionProgramEditor_programNo', {number: programNo})}}</strong>
        <button
            v-show="isShowDelete"
            type="button"
            class="btn_input sm del"
            @click.prevent="deleteProgram"
        >{{$t('EnrolmentQuestionProgramEditor_delete')}}
        </button>

        <div class="info_txt full">
            <div class="bx_input_wrap">
                <TextArea
                    ref="input"
                    :id="inputId"
                    :placeholder="$t('EnrolmentQuestionProgramEditor_inputProgramName')"
                    :maxlength="300"
                    v-model="programName"
                    cols="50"
                    rows="1"
                    label-class="input_lbl"
                    label-tag="label"
                    :resize="true"
                    :one-line="true"
                    @keydown.native="focusNextProgram"
                />
            </div>
        </div>
        <div class="info_txt desc_txt full">
          <div class="bx_input_wrap">
                    <TextArea
                        ref="input"
                        :id="inputId"
                        placeholder="강좌에 대한 보충 설명을 입력해 주세요. (선택입력/500자 이내)"
                        :maxlength="300"
                        v-model="programDesc"
                        cols="50"
                        rows="3"
                        label-class="input_lbl"
                        label-tag="label"
                        :resize="true"
                        :one-line="false"
                        @keydown.native="focusNextProgram"
                    />
          </div>
        </div>

        <ul class="info_class">
            <EnrolmentQuestionProgramCountEditor
                :question-index="questionIndex"
                :program-index="programIndex"
            />
            <EnrolmentQuestionProgramGradeEditor
                :question-index="questionIndex"
                :program-index="programIndex"
            />
        </ul>

        <div class="detail_class">
            <EnrolmentQuestionProgramTimeEditor
                :question-index="questionIndex"
                :program-index="programIndex"
            />
            <EnrolmentQuestionProgramCostEditor
                :question-index="questionIndex"
                :program-index="programIndex"
            />
        </div>
    </div>
</template>

<script>
import {DELETE_PROGRAM} from "@common/store/modules/enrolment/editor.js";
import {mapActions} from "vuex";
import TextArea from "@iamteacherpc/components/common/TextArea.vue";
import EnrolmentQuestionProgramCountEditor from '@iamteacherpc/components/editor/EnrolmentQuestionProgramCountEditor';
import EnrolmentQuestionProgramGradeEditor from '@iamteacherpc/components/editor/EnrolmentQuestionProgramGradeEditor';
import EnrolmentQuestionProgramTimeEditor from '@iamteacherpc/components/editor/EnrolmentQuestionProgramTimeEditor';
import EnrolmentQuestionProgramCostEditor from '@iamteacherpc/components/editor/EnrolmentQuestionProgramCostEditor';
import {requestConfirm} from '@iamteacherpc/utils/iframe';
import {LIST_CHANGE, STOP_LIST_CHANGE} from '@common/store/modules/common/editor/questionList';

export default {
    name: "EnrolmentQuestionProgramEditor",
    components: {
        EnrolmentQuestionProgramCostEditor,
        EnrolmentQuestionProgramTimeEditor,
        EnrolmentQuestionProgramGradeEditor, EnrolmentQuestionProgramCountEditor, TextArea,
    },

    props: {
        questionIndex: {
            type: Number,
            required: true,
        },
        programIndex: {
            type: Number,
            required: true,
        },
    },

    computed: {
        isShowDelete() {
            return this.$store.getters['enrolment/getField'](`form.questions[${this.questionIndex}].programs`).length > 1;
        },

        programNo() {
            return this.programIndex + 1
        },

        inputId() {
            return `program-${this.questionIndex}-${this.programIndex}`;
        },

        programName: {
            get() {
                return this.$store.getters['enrolment/getField'](`${this.getStorePath()}.programName`);
            },
            set(newValue) {
                this.$store.commit('enrolment/updateField', {
                    path: `${this.getStorePath()}.programName`,
                    value: newValue,
                });
            },
        },
      programDesc: {
        get() {
          return this.$store.getters['enrolment/getField'](`${this.getStorePath()}.programDesc`);
        },
        set(newValue) {
          this.$store.commit('enrolment/updateField', {
            path: `${this.getStorePath()}.programDesc`,
            value: newValue,
          });
        },
      },
    },

    methods: {
        ...mapActions('enrolment', {
            storeDeleteProgram: DELETE_PROGRAM,
            stopListChange: STOP_LIST_CHANGE,
            listChange: LIST_CHANGE,
        }),

        getStorePath() {
            return `form.questions[${this.questionIndex}].programs[${this.programIndex}]`;
        },

        async deleteProgram() {
            try {
                this.stopListChange();

                await requestConfirm({
                    title: this.$t('EnrolmentQuestionProgramEditor_confirmDelete'),
                });

                this.storeDeleteProgram({
                    questionIndex: this.questionIndex,
                    programIndex: this.programIndex,
                });
            } catch (e) {
                if (e) {
                    throw e;
                }
            } finally {
                this.listChange();
            }
        },

        focusProgram() {
            this.$refs.input.focus();
        },

        focusNextProgram(event) {
            if (event.keyCode !== 13) {
                return;
            }

            this.$emit('focusNextProgram');
        },
    },
}
</script>

<style scoped lang="scss">
.info_txt {
  &.desc_txt {
    margin-top:10px;
    margin-left: 0 !important;
  }
}
</style>
